module.exports = __webpack_public_path__ + "img/sort.18516579.svg";